import { render, staticRenderFns } from "./WriteEdition.vue?vue&type=template&id=401811de&scoped=true&"
import script from "./WriteEdition.vue?vue&type=script&lang=js&"
export * from "./WriteEdition.vue?vue&type=script&lang=js&"
import style0 from "./WriteEdition.vue?vue&type=style&index=0&id=401811de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401811de",
  null
  
)

component.options.__file = "WriteEdition.vue"
export default component.exports